const initialState = () => ({
    all: []
});

const depositTicketReducer = (state = initialState(), action) => {
    const newState = Object.assign({}, state);
    switch (action.type) {
        case 'ATTACHMENT_RECEIVED':
            newState.all = action.payload;
            return newState;
        case 'ATTACHMENT_CREATED':
            newState.all.push(action.payload);
            return newState;
        case 'ATTACHMENT_EDITED':
            newState.all.forEach((attachment, idx) => {
                if (attachment.id === action.payload.id) {
                    newState.all[idx] = {...action.payload };
                }
            });
            return newState;
        case 'ATTACHMENT_DELETED':
            newState.all.forEach((attachment, idx) => {
                if (attachment.id === action.payload) {
                    newState.all.splice(idx, 1);
                }
            });
            return newState;
        case 'ATTACHMENT_UPLOAD_PICTURES_SUCCESS':
            newState.all.forEach((att, idx) => {
                // [0] because all images are on same event
                if (parseInt(att.id) === parseInt(action.payload[0].data.attachment_id)) {
                    action.payload.forEach(row => {
                        newState.all[idx].pictures.push(row.data);
                    });
                }
            });
            return newState;
        case 'PICTURE_UPDATED':
            if (!action.payload.attachment_id) return state;
            newState.all.forEach((m, idx) => {
                if (m.id === action.payload.attachment_id) {
                    newState.all[idx].pictures.forEach((p, m_idx) => {
                        if (newState.all[idx].pictures[m_idx].id === action.payload.id) {
                            newState.all[idx].pictures[m_idx].comment = action.payload.comment;
                        }
                    });
                }
            });
            return newState;
        case 'PICTURE_REMOVE_SUCCESS':
            if (!action.payload.attachment_id) return state;
            newState.all.forEach((m, idx) => {
                if (m.id === action.payload.attachment_id) {
                    newState.all[idx].pictures.forEach((p, m_idx) => {
                        if (newState.all[idx].pictures[m_idx].id === action.payload.id) {
                            newState.all[idx].pictures.splice(m_idx, 1);
                        }
                    });
                }
            });
            return newState;
        case 'LOGOUT':
            return Object.assign({}, initialState());
        default:
            return state;
    }
};

export default depositTicketReducer;
